import * as Sentry from "@sentry/react"
import { Integrations } from "@sentry/tracing"
import { Replay } from "@sentry/replay"

import version from "../version.json"

const hostname = new URL(window.location).hostname
const reportErrors = hostname.endsWith("altrio.com")
const environment = ["origin.altrio.com", "platform.altrio.com"].includes(
  hostname
)
  ? "production"
  : "staging"

export const registerSentry = () => {
  if (reportErrors) {
    Sentry.init({
      dsn: "https://69a78b05a88942c4a588a03edbb7a6a8@o391655.ingest.sentry.io/5238173",
      release: version.release_sha,
      environment,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
      integrations: [new Integrations.BrowserTracing(), new Replay()],
      tracesSampleRate: 0.5, // Sample rate 50%
    })
  }
}

export const addUserScope = ({ email_address, id, first_name, last_name }) => {
  if (reportErrors) {
    Sentry.configureScope(function (scope) {
      scope.setUser({
        email: email_address,
        id,
        username: `${first_name} ${last_name}`,
      })
    })
  }
}
